import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Note from './Note/component';

export class Student extends PureComponent {
  componentDidMount() {
  }

  render() {
    return <div className={styles.Student}>
      <Note studentId={this.props.params.studentId} />
    </div>;
  }
}

Student.propTypes = {
  params: PropTypes.object,
};

export default Student;



// WEBPACK FOOTER //
// ./containers/Student/component.jsx